import { trigger, transition, style, animate, group, query } from '@angular/animations';

export const pageTransition = trigger('pageTransition', [
  //special care for initial animation
  transition('void => *', [
    style({
      position: 'absolute',
      top: '0px',
      left: '0px',
      right: '0px',
      bottom: '0px',
    }),
    style({ transform: 'scale(0.5)', opacity: 0 }),
    animate('500ms ease-out', style({ transform: 'scale(1)', opacity: 1 }))
  ]),
  transition('* <=> *', [
    style({
      position: 'absolute',
      top: '0px',
      left: '0px',
      right: '0px',
      bottom: '0px',
    }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px'
      }),
    ], { optional: true }),
    query(':enter', [
      style({ transform: 'scale(0.5)', opacity: 0 }),
    ], { optional: true }),
    query(':leave', [
      style({ opacity: 1 }),
    ], { optional: true }),
    group([
      query(':leave', [
        animate('500ms ease-out', style({ transform: 'scale(0.5)', opacity: 0.1 })),
      ], { optional: true }),
      query(':enter', [
        animate('500ms ease-out', style({ transform: 'scale(1)', opacity: 1 })),
      ], { optional: true }),
    ]),
  ]),
]);